(function (root) {
  'use strict';
  const STYLES = new Set(['polaroid', 'mp3', 'social-instagram']);
  class CupSetModel {
    constructor(total, style) {
      if (!STYLES.has(style)) throw new Error('Ungültiger Produktstil.');
      this.style = style;
      this.designs = [];
      this.setTotal(total);
    }
    setTotal(total) {
      if (!Number.isInteger(total) || total < 10 || total > 60 || total % 10) throw new Error('Bitte wähle 10, 20, 30, 40, 50 oder 60 Cups.');
      this.total = total;
    }
    get assigned() { return this.designs.reduce((n, d) => n + d.count, 0); }
    get remaining() { return this.total - this.assigned; }
    get complete() { return this.designs.length > 0 && this.remaining === 0; }
    upsert(design) {
      if (design.style !== this.style) throw new Error('Alle Motive müssen zum gewählten Produktstil gehören.');
      if (!Number.isInteger(design.count) || design.count < 1 || design.count > this.total) throw new Error('Bitte eine gültige ganze Stückzahl wählen.');
      if (!/^[A-Za-z0-9_-]{1,64}$/.test(design.id || '')) throw new Error('Das Motiv konnte nicht zugeordnet werden.');
      const existing = this.designs.findIndex(d => d.id === design.id);
      const previous = existing < 0 ? 0 : this.designs[existing].count;
      if (this.assigned - previous + design.count > this.total) throw new Error('Die Motiv-Anzahlen sind größer als dein Set. Bitte passe sie an.');
      if (existing < 0) this.designs.push(design);
      else this.designs[existing] = design;
    }
    remove(id) { this.designs = this.designs.filter(d => d.id !== id); }
    summary() {
      return this.total + ' Cups · ' + this.designs.length + (this.designs.length === 1 ? ' Motiv' : ' unterschiedliche Motive');
    }
    manifest() {
      if (!this.complete) throw new Error(this.remaining > 0 ? 'Noch ' + this.remaining + ' Cups gestalten oder einem Motiv zuordnen.' : 'Bitte die Motiv-Anzahlen an die gewählte Setgröße anpassen.');
      return {
        version: 1, style: this.style, total: this.total,
        designs: this.designs.map((d, i) => {
          const prefix = '_M' + String(i + 1).padStart(2, '0');
          return { id: d.id, count: d.count, style: this.style,
            printKey: prefix + 'Druck', sourceKey: prefix + 'Foto', previewKey: '_M01Vorschau',
            previewRect: {x:(i%5)*240,y:Math.floor(i/5)*240,width:240,height:240},
            fields: d.fields, background: d.background, parameters: d.parameters };
        })
      };
    }
    static validate(manifest, total, style) {
      if (!manifest || ![1,2].includes(manifest.version) || manifest.style !== style || manifest.total !== total || !Array.isArray(manifest.designs) || manifest.designs.length < 1 || manifest.designs.length > total) throw new Error('Die gespeicherte Motivaufteilung ist ungültig.');
      const model = new CupSetModel(total, style);
      const ids = new Set();
      for (const d of manifest.designs) {
        if (ids.has(d.id)) throw new Error('Ein Motiv ist doppelt zugeordnet.');
        ids.add(d.id);
        if (!/^#[a-f0-9]{6}$/i.test(d.background || '') || !d.fields || typeof d.fields !== 'object' || !d.parameters || d.parameters.style !== style) throw new Error('Die Gestaltung eines Motivs ist unvollständig.');
        for (const key of ['printKey','sourceKey','previewKey']) if (!/^_M\d{2}(Druck|Foto|Vorschau)$/.test(d[key] || '')) throw new Error('Eine Motiv-Datei fehlt.');
        if(d.previewRect){const r=d.previewRect;if(![r.x,r.y,r.width,r.height].every(Number.isInteger)||r.x<0||r.y<0||r.width!==240||r.height!==240||r.x+240>1200||r.y+240>2880)throw new Error('Eine Motiv-Vorschau ist ungültig.');}
        if(manifest.version===2)for(const key of [d.printKey,d.sourceKey]){const a=manifest.assets?.[key];if(!a||!/^_M\d{2}Paket$/.test(a.packageKey)||!/^M\d{2}-(druck\.png|foto\.(png|jpg|webp))$/.test(a.entry))throw new Error('Eine Motiv-Datei fehlt.');}
        model.upsert(d);
      }
      if (!model.complete) throw new Error('Die Motiv-Anzahlen stimmen nicht mit der Setgröße überein.');
      return model;
    }
  }
  root.TheCupLabSetModel = CupSetModel;
  if (typeof module !== 'undefined' && module.exports) module.exports = CupSetModel;
})(typeof window !== 'undefined' ? window : globalThis);
